import { ProductWithRelations } from "Types";

export const getHighAndLowestPrice = (
  item: ProductWithRelations
): {
  uniquePrice?: number;
  highestPrice?: number;
  lowestPrice?: number;
  lowestPromotionalPrice?: number;
  highestPromotionalPrice?: number;
} => {
  const basePrice = item.price || 0;
  const promotionalPrice = item.price_promotional || 0;
  if (!item.variants) {
    return { uniquePrice: basePrice };
  }
  const optionsPrices = item.variants.reduce(
    (acc: { lowest: number[][]; highest: number[][] }, variant) => {
      const optionsPrice = variant.options.map((option) => option.price);
      if (variant.isRequired) {
        acc.lowest.push(optionsPrice);
      }
      acc.highest.push(optionsPrice);
      return acc;
    },
    { lowest: [], highest: [] }
  );
  const lowestPrice = optionsPrices.lowest.reduce((acc, option) => {
    const lowestOptionPrice = Math.min(...option);
    return acc + lowestOptionPrice;
  }, basePrice);
  const lowestPromotionalPrice = optionsPrices.lowest.reduce((acc, option) => {
    const lowestOptionPrice = Math.min(...option);
    return acc + lowestOptionPrice;
  }, promotionalPrice);

  const highestPrice = optionsPrices.highest.reduce((acc, option) => {
    const highestOptionPrice = Math.max(...option);
    return acc + highestOptionPrice;
  }, basePrice);
  const highestPromotionalPrice = optionsPrices.highest.reduce(
    (acc, option) => {
      const highestOptionPrice = Math.max(...option);
      return acc + highestOptionPrice;
    },
    promotionalPrice
  );

  if (lowestPrice === highestPrice) {
    return { uniquePrice: lowestPrice };
  }
  return {
    lowestPrice,
    highestPrice,
    lowestPromotionalPrice,
    highestPromotionalPrice,
  };
};
